import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  textWrap: {
    paddingTop: '20px',
    paddingBottom: '20px',
    textAlign: 'center',
  },
  text: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    color: '#999999',
    margin: '0',
  },
  button: {
    width: '210px',
    padding: '8px 0',
    backgroundColor: '#C74060',
    color: '#ffffff',
    border: '1px solid #C74060',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  },
};

const ErrorPanel = ({ onReload }) => {
  const { t } = useTranslation();
  const staticResourceHost = window.mainConfig?.staticResourceHost;

  return (
    <div style={styles.container}>
      <img
        src={`${staticResourceHost}admin/v2/img/member_center/member_center_page_error.png`}
        width="108"
        alt=""
      />
      <div style={styles.textWrap}>
        <p style={styles.text}>{t('Error Panel - Unknown Error')}</p>
        <p style={styles.text}>{t('Error Panel - Refresh Hint')}</p>
      </div>
      <button style={styles.button} onClick={onReload}>
        {t('Error Panel - Try Again')}
      </button>
    </div>
  );
};

ErrorPanel.propTypes = {
  onReload: PropTypes.func.isRequired,
};

export default ErrorPanel;
